<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<img v-if="src" style="z-index:9999;width:480px;height:320px;position:absolute;left:0px;bottom: 0px;" :src="src" />
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="purchasesplittable"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="打印" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
		<vxe-modal v-model="splitconfigShow" title="拆包" :width="500" :height="300" show-footer destroy-on-close>
			<template #default>
				<el-form ref="form" :model="splitconfig" label-width="50px" size="small">
					<el-form-item label="类型" style="margin-top: 20px;">
						<el-radio-group v-model="splitconfig.type" @change="splitconfigtypeChange">
							<el-radio :label="1">包数</el-radio>
							<el-radio :label="2">每包数量</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="数量" style="margin-top: 20px;">
						<el-input-number v-model="splitconfig.num" :min="1" ></el-input-number>
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="splitcancel"></vxe-button>
				<vxe-button status="primary" content="确认" @click="splitsubmit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import {
		DTPWeb
	} from 'dtpweb'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			row: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '打印质检码',
				modal_model: false,
				modal_width: 1000,
				modal_height: 500,
				splitconfigShow: false,
				splitconfig:{
					type:1,
					num:1
				},
				goodsrow:null,
				src:null
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			splitsubmit(){
				let size = []
				if(this.splitconfig.type==1){				
					this.goodsrow.printnum = this.splitconfig.num
					size = this.splitEvenly(this.goodsrow.size,this.goodsrow.printnum)
				}
				if(this.splitconfig.type==2){
					size = this.calculatePacks(this.goodsrow.size,this.splitconfig.num)
					this.goodsrow.printnum = size.length
				}
				this.goodsrow.splitsize = size.join('|',size)
				this.splitcancel()
			},
			splitcancel(){
				this.splitconfigShow = false
				this.splitconfig = {
					type:1,
					num:1
				}
			},
			split(row) {
				this.splitconfigShow = true
				this.goodsrow = row
			},
			splitconfigtypeChange(e){
				if(e==1){
					this.splitconfig.num = 1
				}
				if(e==2){
					this.splitconfig.num = this.goodsrow.size
				}
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
							field: 'skuCode',
							title: '产品编码',
						},
						{
							field: 'goodsName',
							title: '产品名称'
						},
						{
							field: 'skuName',
							title: '规格'
						},
						{
							field: 'splitsize',
							title: '数量',
						},
						{
							field: 'printnum',
							title: '打印数量',
							editRender:{
								name:'$inputNumber',
								props:{
									precision:0
								}
							},
						},
						{
							field: 'canprint',
							title: '是否打印',
							align:'center',
							width:100,							
							cellRender:{
								name:'$switch',
							},
							contentRender:{
								name:'$switch',
							}
						},
						// {
						// 	title: '操作',
						// 	fixed: "right",
						// 	align: 'center',
						// 	width: 65,
						// 	slots: {
						// 		default: ({
						// 			row
						// 		}) => {
						// 			return [ <el-button type = "text" size = "mini" onClick = {() => {this.split(row)}} > 拆包 </el-button> ]
						// 			}
						// 		}
						// 	}
						]
						gridOptions.formConfig = false
					},
					list() {
						return new Promise((resolve) => {
							this.$api.wlnpurchase.getDetail({
								ids: this.row.billID
							}).then((res) => {
								res.forEach((item) => {
									item.size = parseInt(item.size)
									item.printnum = 1
									item.canprint = true
									item.splitsize = item.size
								})
								resolve({
									list: res
								})
							})
						})
					},
					async submit() {
						let data = []
						let fullData = this.$refs.purchasesplittable.getTableData().fullData
						fullData.forEach((item)=>{
							if(item.canprint){
								for(let index = 0; index<item.printnum; index++){
									data.push({
										billID:this.row.billID,
										detailID:item.detailID,
										skuID:item.skuID,
										splitsize:item.splitsize,
										printnum:item.printnum,
										billCode:this.row.billCode,
										goodsName:item.goodsName,
										skuName:item.skuName,
										unitName:item.unitName,
										index:index+1
									})
								}							
							}
						})
						this.$api.wlnpurchase.getlabelid({data:data}).then(async (res)=>{
							let api = await DTPWeb.checkServer()
							//console.log(api,1111111111)							
							let printers = await api.getPrinters({ onlyLocal: true })
							if(!printers.length){
								this.$message.error('未连接打印机')
								return
							}
							await api.openPrinter(printers[0]);
							for (const item of res) {
								await this.print(api,item.data,'https://wz-nazhi.com/H5/qualitytest?id='+item.id)
							}
						})
						// for (const item of fullData) {
						// 	if(item.canprint){
						// 		for(let index = 0; index<item.printnum; index++){
						// 			//let qrcodetext = 'a2c20d76-637b-11f0-bd6a-5b2b1d13485c'
						// 			//await this.print(item,index+1,qrcodetext)
						// 		}							
						// 	}
						// }
						console.log(data)
						//await this.print(item,qrcodetext)
						
						
						//this.init()
					},
					reset() {
						//this.init()
					},
					async print(api,detail,qrcodetext) {

						// const printerName = "DT60 Label Printer";
						// const labelWidth = 40;
						// const labelHeight = 30;
						// const text = "https://www.detonger.com"
						// const fontHeight = 3;
						//var api = DTPWeb.getInstance({});


						var labelWidth = 60;
						var labelHeight = 40;
						var margin = 2;
						await api.startPrintJob({
							width: labelWidth,
							height: labelHeight,
							orientation: 0,
							//jobName: "#!#Preview#!#",
							jobName: "DTPWeb",
							printerWidth: labelWidth,
						});
						await api.drawTable({
							x: margin,
							y: 1,
							width: labelWidth - margin * 2,
							height: labelHeight - margin * 2,
							rowCount: 8,
							columnCount: 6,
							//columnWidths: [0.1, 0.1, 0.1],
							lineWidth: 0.2,
							fontHeight: 2.5,
							tableRows: [
								[{
									type: "text",
									text: "纳智入库质检码",
									fontHeight: 3.5,
									columnSpan: 6,
								}, ],
								[{
										text: "单号"
									},
									{
										text: detail.billCode,
										horizontalAlignment: 0,
										columnSpan: 5
									},
								],
								[{
										text: "品名"
									},
									{
										text: detail.goodsName,
										horizontalAlignment: 0,
										columnSpan: 5,
									},
								],
								[{
										text: "规格"
									},
									{
										text: detail.skuName,
										horizontalAlignment: 0,
										columnSpan: 5
									},
								],
								[{
										text: "数量"
									},
									{
										text: detail.splitsize,
										columnSpan: 2,
									},
									{
										text: detail.unitName,
									},		
									{
										text: detail.unitName,
									},	
									{
										type: "qrcode",
										text:qrcodetext,
										rowSpan: 4,
										columnSpan: 2,
										margin: 0.5,
									},
								],
								[
									{
										text: "序号"
									},
									{
										text: detail.index+'/'+ detail.printnum,
										columnSpan: 3
									}
								],
								[
									{
										text: "备注",
										rowSpan: 2
									},
									{
										text: '',
										horizontalAlignment: 0,
										columnSpan: 3,
										rowSpan: 2
									}
								],
							],
						});

						api.commitJob({
							darkness:15,
							gapType:2,
							speed:4,
							callback:(res)=>{
								console.log(res,123)
							}
						})
						
						// let w = api.mm2Pix(labelWidth)
						// let h = api.mm2Pix(labelHeight)
						// console.log(w,h,JSON.stringify({
						// 					billCode:this.row.billCode,
						// 					skuCode:detail.skuCode,
						// 					splitsize:num,
						// 					index:index
						// 				}))
						// if(res && res.previewData){
						// 	this.src = res.previewData[0]
						// }
						
						// 4. 结束绘制操作，开始打印
						//await api.commitJob();
						// 5. 关闭已经打开的打印机
						//await api.closePrinter();

					},
					splitEvenly(total, parts = 1) {
						if (parts <= 0) return [];
						const base = Math.floor(total / parts);
						const remainder = total % parts;					    
						return Array(parts).fill(base)
								.map((val, i) => i < remainder ? val + 1 : val);
					},
					calculatePacks(total, packSize = 1) {
						if (packSize <= 0) return []; 
						const fullPacks = Math.floor(total / packSize);
						const remaining = total % packSize;
						const packs = Array(fullPacks).fill(packSize);
						if (remaining > 0) {
							packs.push(remaining);
						}
						return packs;
					}
			},
			components: {

			}
		}
</script>